export default "__VITE_ASSET__j_qI3OUW__"